<template>
    <div>
        <Title :title="'竞赛管理'" ></Title>

        <Menu mode="horizontal" :theme="'light'" :active-name="active" class="tabs" @on-select="menuChange">
            <MenuItem name="list">
                全部竞赛
            </MenuItem>
            <MenuItem name="dataSetList">
                数据集管理
            </MenuItem>
            <MenuItem name="imagesList">
                镜像管理
            </MenuItem>
        </Menu>

        <div>
            <component :is="currentPage" ></component>
        </div>

    </div>
</template>
<style scoped lang="less">
    @import "../../style/index";
</style>
<script>
    import Title from "../../../ability/components/title";
    import List from "./list"
    import DataSetList from "./dataSetList"
    import ImagesList from "./imagesList"

    export default {
        name:'contest',
        components:{
            Title,
            List,
            DataSetList,
            ImagesList
        },
        data(){
            return {
                active:'list',
                currentPage:'List'
            }
        },
        methods:{
            menuChange(name){
                this.active = name;
                this.currentPage = name
            }
        },
        created() {
            let current = this.$route.params.current;
            if(current == undefined){
                this.active = 'list';
                this.currentPage = 'List';
            }else{
                this.active = current;
                this.currentPage = current;
            }
        }

    }
</script>